import $ from 'jquery';
import { isMobile } from '../_shared/helpers';

export default class PromptInstallAndroid {
  constructor() {
    this.$banner = $('.js-banner-install-app');
    this.$btn = $('.js-btn-install-app');
    this.$btnClose = $('.js-btn-close-install-banner');
    this.$90daysPeriod = 7776000000;
    this.init();
  }

  init() {
    if (isMobile()) {
      $(window).on('beforeinstallprompt', (e) => {
        e.preventDefault();
        const hideBannerInstallApp = window.localStorage.getItem('hideBannerInstallApp');

        if (new Date().getTime() > hideBannerInstallApp) {
          this.deferredPrompt = e.originalEvent;
          this.$banner.css('display', 'flex');
        }
      });
    }

    this.$btn.on('click', () => {
      // hide our user interface that shows our A2HS button
      this.$banner.hide();
      // Show the prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            // eslint-disable-next-line no-console
            console.log('User accepted the A2HS prompt');
          } else {
            // eslint-disable-next-line no-console
            console.log('User dismissed the A2HS prompt');
          }
          this.deferredPrompt = null;
        });
    });

    this.$btnClose.on('click', () => {
      this.$banner.hide();
      // set 90 days period to show BannerInstallApp again
      window.localStorage.setItem('hideBannerInstallApp', JSON.stringify(new Date().getTime() + this.$90daysPeriod));
    });
  }
}
